import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-credit-card',
  templateUrl: './icon-credit-card.component.html',
  styleUrls: ['./icon-credit-card.component.scss'],
  standalone: true,
})
export class IconCreditCardComponent {
  @Input() color = '#E8EEF2';
  @Input() width = '20';
  @Input() height = '20';
}
